"use client";
import React from "react";
import { Modal } from "./Modal";
import { ActionButton } from "../buttons/ActionButton";

interface DebugInfo {
  selectedPair: string;
  selectedTimeframe: string;
  selectedExchange: string;
  candlesCount: number;
  plasmaLinesCount?: number;
  supportCount?: number;
  resistanceCount?: number;
  vectorSignalsCount?: number;
  breakoutSignalsCount?: number;
  enabledIndicators?: string[];
  availableIndicators?: string[];
  socketStatus: string;
  error: string | null;
}

interface DebugModalProps {
  isVisible: boolean;
  onClose: () => void;
  debugInfo: DebugInfo;
}

export const DebugModal: React.FC<DebugModalProps> = ({
  isVisible,
  onClose,
  debugInfo,
}) => {
  return (
    <Modal isVisible={isVisible} onClose={onClose} title="Debug Information">
      <div className="space-y-2 text-white text-sm">
        <p>
          Pair: <span className="text-blue-300">{debugInfo.selectedPair}</span>
        </p>
        <p>
          Timeframe:{" "}
          <span className="text-blue-300">{debugInfo.selectedTimeframe}</span>
        </p>
        <p>
          Exchange:{" "}
          <span className="text-blue-300">{debugInfo.selectedExchange}</span>
        </p>

        <div className="mt-3">
          <div className="font-semibold">Data</div>
          <p>Candles: {debugInfo.candlesCount}</p>
          {typeof debugInfo.plasmaLinesCount === "number" && (
            <p>Plasma lines: {debugInfo.plasmaLinesCount}</p>
          )}
          {(typeof debugInfo.supportCount === "number" ||
            typeof debugInfo.resistanceCount === "number") && (
            <p>
              Support/Resistance: {debugInfo.supportCount ?? 0} /{" "}
              {debugInfo.resistanceCount ?? 0}
            </p>
          )}
          {typeof debugInfo.vectorSignalsCount === "number" && (
            <p>Vector signals: {debugInfo.vectorSignalsCount}</p>
          )}
          {typeof debugInfo.breakoutSignalsCount === "number" && (
            <p>Breakout signals: {debugInfo.breakoutSignalsCount}</p>
          )}
        </div>

        <div className="mt-3">
          <div className="font-semibold">Indicators</div>
          <p>
            Enabled: {debugInfo.enabledIndicators?.length ?? 0}
            {debugInfo.enabledIndicators?.length
              ? ` — ${debugInfo.enabledIndicators?.join(", ")}`
              : ""}
          </p>
          <p>
            Available: {debugInfo.availableIndicators?.length ?? 0}
            {debugInfo.availableIndicators?.length
              ? ` — ${debugInfo.availableIndicators?.join(", ")}`
              : ""}
          </p>
        </div>

        <p className="mt-3">WebSocket: {debugInfo.socketStatus}</p>
        {debugInfo.error && (
          <p className="text-red-500">Error: {debugInfo.error}</p>
        )}
      </div>
      <div className="mt-4 flex justify-end">
        <ActionButton onClick={onClose} label="Close" variant="secondary" />
      </div>
    </Modal>
  );
};
